<template>
	<div class="safety-stock-price-rule">
		<div class="page-info">
			<span class="info-tag">通用安全库存规则改价格</span>
			适用于商品配置的「通用安全库存规则改价格」，此规则即更新线上商品库存，同时更新新商品价格，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<div class="page-tips page-tips--warn">
			<p>提示：安全折扣是当渠道折扣高于设定的折扣时，代理认为折扣太高，不适合销售。一般建议设置为8折，就是渠道折扣超过8,就不再计算库存上架。各代理可以根据自身店铺情况进行设置。</p>
		</div>

		<div class="save-bar">
			<el-button type="primary" :loading="saving" @click="onSaveAll">保存全部</el-button>
			<span class="save-note">{{ showStockConfig ? '保存全部后，页面中设置的安全库存才能生效（安全库存默认 5，安全折扣默认 10，不限制）' : '保存全部后，参数配置才能生效' }}</span>
		</div>

		<el-form ref="form" v-loading="loading" :model="form" :rules="rules" label-width="240px" class="config-form">
			<el-collapse v-model="activeCollapse" class="rule-collapse" @change="onCollapseChange">
				<el-collapse-item title="根据安全库存自动匹配渠道规则设置" name="channel" class="collapse-narrow">
					<div class="page-tips page-tips--inner">
						<p class="tips-hint">提示：对于退货政策为100%+0%的渠道综合代理价=代理价；对于退货政策为0%+100%的渠道综合代理价=代理价*(1+渠道不支持退货代理价加点/100)；</p>
						<p class="tips-hint">提示：对于其他退货政策的渠道综合代理价计算方式，得分=50+免费退货比例/100*50+(4/100-超出扣款比率/100)*400，加价百分比=(1-得分/100)*渠道不支持退货代理价加点/100，渠道综合代理价=代理价*(1+加价百分比)</p>
						<p class="tips-hint">提示：渠道不支持退货代理价加点，对于退货政策为0%+100%的渠道代理价加价比率，如代理价为100，当前设定参数为5，则综合代理价为105，计算{{ platformName }}商品价格以105为准</p>
					</div>
					<el-form-item label="单款尺码毛利润 (%)" prop="grossProfit">
						<div class="field-wrap">
							<el-input-number v-model="form.grossProfit" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">若设置了阶梯毛利润，则以阶梯毛利润为准</p>
						</div>
					</el-form-item>
					<el-form-item label="渠道不支持退货代理价加点 (%)" prop="nonReturnMarkup">
						<div class="field-wrap">
							<el-input-number v-model="form.nonReturnMarkup" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">针对 0%+100% 退货政策渠道的加价比例；例如代理价 100、加点 5，综合代理价 105</p>
						</div>
					</el-form-item>
					<el-form-item label="不追渠道折扣大于多少不推库存" prop="nonReturnDiscount">
						<div class="field-wrap">
							<el-input-number v-model="form.nonReturnDiscount" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">仅针对 0%+100% 退货政策渠道，0 表示不控制</p>
						</div>
					</el-form-item>
					<el-form-item :label="platformDeductionLabel" prop="pddDeduction">
						<div class="field-wrap">
							<el-input-number v-model="form.pddDeduction" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">用于云库存价格计算</p>
						</div>
					</el-form-item>
					<el-form-item label="运费" prop="postage">
						<div class="field-wrap">
							<el-input-number v-model="form.postage" :min="0" :precision="2" :controls="false" />
						</div>
					</el-form-item>
					<el-form-item label="配货率 (%)" prop="allocationRate">
						<div class="field-wrap">
							<el-input-number v-model="form.allocationRate" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">低于此配货率的渠道不推送</p>
						</div>
					</el-form-item>
					<el-form-item label="准时率 (%)" prop="onTimeRate">
						<div class="field-wrap">
							<el-input-number v-model="form.onTimeRate" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">低于此准时率的渠道不推送</p>
						</div>
					</el-form-item>
					<el-form-item label="预发日期" prop="shipDays">
						<div class="field-wrap">
							<el-select v-model="form.shipDays" placeholder="请选择">
								<el-option v-for="item in shipDateOptions" :key="item.value" :label="item.label" :value="item.value" />
							</el-select>
						</div>
					</el-form-item>
					<el-form-item label="退货政策" prop="returnPolicy">
						<el-radio-group v-model="form.returnPolicy" class="radio-group" @change="blurActiveElement">
							<el-radio label="none">不做控制</el-radio>
							<el-radio label="exclude0_100">自动匹配渠道时，不匹配退货政策 0%+100% 的渠道</el-radio>
							<el-radio label="only100_0">自动匹配渠道时，只匹配退货政策 100%+0% 的渠道</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="撕防伪状态" prop="securityStatus">
						<el-radio-group v-model="form.securityStatus" @change="blurActiveElement">
							<el-radio label="all">全部</el-radio>
							<el-radio label="tear">撕防伪</el-radio>
							<el-radio label="no_tear">不撕防伪</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="渠道集" prop="channelSet">
						<el-radio-group v-model="form.channelSet" @change="blurActiveElement">
							<el-radio label="all">全部</el-radio>
							<el-radio label="mandatory_backup">必选渠道+备选渠道</el-radio>
						</el-radio-group>
					</el-form-item>
				</el-collapse-item>

				<el-collapse-item title="价格更新规则" name="price" class="collapse-narrow">
					<el-form-item v-if="!isTaobao" label="单买价加价金额 (元)" prop="singleBuyMarkup">
						<div class="field-wrap">
							<el-input-number v-model="form.singleBuyMarkup" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">单买价 = {{ priceUnitLabel }} + 单买价加价金额</p>
						</div>
					</el-form-item>
					<el-form-item label="保价天数" prop="priceProtectDays">
						<div class="field-wrap">
							<el-input-number v-model="form.priceProtectDays" :min="0" :precision="0" :step="1" :controls="false" />
							<p class="field-tip">填写0表示忽略此项配置；填写7则表示7天内若商品降价则不会更新线上价格，上涨则会更新，此sku的最新订单支付时间+n天</p>
						</div>
					</el-form-item>
					<el-form-item label="价格上涨不更新价格(%)，范围内" prop="priceUpInRange">
						<div class="field-wrap">
							<el-input-number v-model="form.priceUpInRange" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">填写0表示忽略此项配置；当价格上涨幅度小于百分之多少，不更新当前商品价格；临界值={{ platformName }}商品当前价*(1+当前设定值/100)，若临界值&gt;{{ platformName }}商品新计算价，则不更新{{ platformName }}价格，库存正常推送</p>
						</div>
					</el-form-item>
					<el-form-item label="价格下跌不更新价格(%)，范围内" prop="priceDownInRange">
						<div class="field-wrap">
							<el-input-number v-model="form.priceDownInRange" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">填写0表示忽略此项配置；当价格下跌幅度小于百分之多少，不更新当前商品价格；临界值={{ platformName }}商品当前价*(1-当前设定值/100)，若临界值&lt;{{ platformName }}商品新计算价，则不更新{{ platformName }}价格，库存正常推送</p>
						</div>
					</el-form-item>
					<el-form-item label="价格上涨不更新价格(%)，范围外" prop="priceUpOutRange">
						<div class="field-wrap">
							<el-input-number v-model="form.priceUpOutRange" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">填写0表示忽略此项配置；当价格上涨幅度大于百分之多少，不更新当前商品价格；临界值={{ platformName }}商品当前价*(1+当前设定值/100)，若临界值&lt;{{ platformName }}商品新计算价，则不更新{{ platformName }}价格，且库存置0</p>
						</div>
					</el-form-item>
					<el-form-item label="价格下跌不更新价格(%)，范围外" prop="priceDownOutRange">
						<div class="field-wrap">
							<el-input-number v-model="form.priceDownOutRange" :min="0" :precision="2" :controls="false" />
							<p class="field-tip">填写0表示忽略此项配置；当价格下跌幅度大于百分之多少，不更新当前商品价格；临界值={{ platformName }}商品当前价*(1-当前设定值/100)，若临界值&gt;{{ platformName }}商品新计算价，则不更新{{ platformName }}价格，库存正常推送</p>
						</div>
					</el-form-item>
					<p class="price-section-note">若设置了阶梯利润，则以阶梯利润为准</p>
				</el-collapse-item>

				<el-collapse-item title="阶梯毛利润配置" name="tier" class="collapse-narrow">
					<div class="tier-header">
						<p class="section-note">若设置了阶梯利润，则以阶梯利润为准</p>
						<el-button type="text" class="tier-add-btn" @click="onAddTier">+ 新增</el-button>
					</div>
					<div class="tier-table">
						<div class="tier-row tier-row--head">
							<span class="col-range">代理价区间 (元)</span>
							<span class="col-profit">毛利润 (%)</span>
							<span class="col-action">操作</span>
						</div>
						<div v-for="(item, index) in form.tierList" :key="item._uid" class="tier-row">
							<div class="col-range">
								<el-input-number v-model="item.priceMin" :min="0" :precision="2" :controls="false" placeholder="最低价" size="small" />
								<span class="range-sep">≤ 代理价 &lt;</span>
								<el-input-number v-model="item.priceMax" :min="0" :precision="2" :controls="false" placeholder="最高价" size="small" />
							</div>
							<div class="col-profit">
								<el-input-number v-model="item.profitRate" :min="0" :precision="2" :controls="false" placeholder="毛利润(%)" size="small" />
							</div>
							<div class="col-action">
								<span class="action-link" @click="onRemoveTier(index)">删除</span>
							</div>
						</div>
					</div>
				</el-collapse-item>

				<el-collapse-item v-if="showStockConfig" title="安全库存配置" name="stock" class="stock-panel-item">
					<div class="stock-panel">
					<div class="stock-tip">提示：安全折扣是当渠道折扣高于设定的折扣时，代理认为折扣太高，不适合销售。一般建议设置为8折，就是渠道折扣超过8,就不再计算库存上架。各代理可以根据自身店铺情况进行设置。</div>
					<div class="batch-bar">
						<span class="batch-label">全局批量修改</span>
						<div class="batch-field">
							<span>安全库存</span>
							<el-input-number v-model="batchStock" :min="0" :precision="0" :step="1" :controls="false" size="small" />
						</div>
						<div class="batch-field">
							<span>安全折扣</span>
							<el-input-number v-model="batchDiscount" :min="0" :precision="2" :step="0.01" :controls="false" size="small" />
						</div>
						<el-button size="small" @click="applyBatch">应用到本页全部</el-button>
					</div>
					<div v-if="!stockCategories.length" class="stock-empty">暂无安全库存配置</div>
					<div
						v-for="category in stockCategories"
						:key="category.key"
						class="stock-category"
					>
						<div class="cat-label">{{ category.name }}</div>
						<div class="size-scroll">
							<div v-for="(item, idx) in category.items" :key="idx" class="size-cell">
								<span class="size-name">{{ item.size }}</span>
								<div class="size-field">
									<span class="field-label">安全库存</span>
									<el-input-number v-model="item.stock" :min="0" :precision="0" :step="1" :controls="false" size="mini" />
								</div>
								<div class="size-field">
									<span class="field-label">安全折扣</span>
									<el-input-number v-model="item.discount" :min="0" :precision="2" :step="0.01" :controls="false" size="mini" />
								</div>
							</div>
						</div>
					</div>
					</div>
				</el-collapse-item>
			</el-collapse>
		</el-form>
	</div>
</template>

<script>
import {
	buildGoodsSafetyStockPriceSavePayload,
	buildSafetyStockPriceSavePayload,
	fetchGoodsPushConfig,
	fetchPushConfig,
	getProductPushConfigId,
	getRetailShopId,
	isProductPushConfigScope,
	mapSafetyStockPriceConfigToForm,
	PUSH_CONFIG_TYPES,
	saveGoodsPushConfig,
	savePushConfig,
	validateProfitTierList,
} from './retailShopPushConfig'
import taobaoPlatformMixin from './taobaoPlatformMixin'

let nextTierUid = 1

const createTierRow = () => ({
	_uid: nextTierUid++,
	priceMin: undefined,
	priceMax: undefined,
	profitRate: undefined,
})

const DEFAULT_TIER_COUNT = 2

const DEFAULT_FORM = {
	grossProfit: 10,
	nonReturnMarkup: 0,
	nonReturnDiscount: 0,
	pddDeduction: 10,
	postage: 120,
	allocationRate: 80,
	onTimeRate: 70,
	shipDays: 3,
	returnPolicy: 'none',
	securityStatus: 'all',
	channelSet: 'all',
	singleBuyMarkup: 20,
	priceProtectDays: 0,
	priceUpInRange: 0,
	priceDownInRange: 0,
	priceUpOutRange: 0,
	priceDownOutRange: 0,
	is_enabled: 1,
	tierList: Array.from({ length: DEFAULT_TIER_COUNT }, createTierRow),
}

export default {
	name: 'SafetyStockPriceRule',
	mixins: [taobaoPlatformMixin],
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			loading: false,
			saving: false,
			activeCollapse: ['channel', 'price', 'tier', 'stock'],
			batchStock: undefined,
			batchDiscount: undefined,
			form: JSON.parse(JSON.stringify(DEFAULT_FORM)),
			rules: {
				grossProfit: [{ required: true, message: '请填写', trigger: 'blur' }],
				nonReturnMarkup: [{ required: true, message: '请填写', trigger: 'blur' }],
				nonReturnDiscount: [{ required: true, message: '请填写', trigger: 'blur' }],
				pddDeduction: [{ required: true, message: '请填写', trigger: 'blur' }],
				postage: [{ required: true, message: '请填写', trigger: 'blur' }],
				allocationRate: [{ required: true, message: '请填写', trigger: 'blur' }],
				onTimeRate: [{ required: true, message: '请填写', trigger: 'blur' }],
				shipDays: [{ required: true, message: '请选择', trigger: 'change' }],
				singleBuyMarkup: [{ required: true, message: '请填写', trigger: 'blur' }],
				priceProtectDays: [{ required: true, message: '请填写', trigger: 'blur' }],
				priceUpInRange: [{ required: true, message: '请填写', trigger: 'blur' }],
				priceDownInRange: [{ required: true, message: '请填写', trigger: 'blur' }],
				priceUpOutRange: [{ required: true, message: '请填写', trigger: 'blur' }],
				priceDownOutRange: [{ required: true, message: '请填写', trigger: 'blur' }],
			},
			shipDateOptions: [
				{ value: 1, label: '当日发货' },
			].concat(Array.from({ length: 14 }, (_, i) => ({
				value: i + 2,
				label: `${i + 2}日内发货`,
			}))),
			stockCategories: [],
		}
	},
	computed: {
		shopName() {
			return (this.retailShop && this.retailShop.shopName) || ''
		},
		showStockConfig() {
			return !isProductPushConfigScope(this.retailShop)
		},
		configFetchKey() {
			if (!this.retailShop) {
				return ''
			}
			if (this.retailShop.pushConfigKey) {
				return this.retailShop.pushConfigKey
			}
			return this.retailShop.currentShopId || ''
		},
	},
	watch: {
		configFetchKey: {
			immediate: true,
			handler(key) {
				if (key) {
					this.fetchConfig()
				} else {
					this.resetForm()
				}
			},
		},
	},
	methods: {
		blurActiveElement() {
			this.$nextTick(function() {
				const el = document.activeElement
				if (el && typeof el.blur === 'function') {
					el.blur()
				}
			})
		},
		onCollapseChange() {
			this.blurActiveElement()
		},
		resetForm() {
			this.form = JSON.parse(JSON.stringify(DEFAULT_FORM))
			this.stockCategories = []
		},
		applyConfig(data) {
			const mapped = mapSafetyStockPriceConfigToForm(
				data,
				createTierRow,
				DEFAULT_TIER_COUNT
			)
			const form = JSON.parse(JSON.stringify(DEFAULT_FORM))
			let key
			for (key in mapped.form) {
				if (mapped.form[key] !== undefined) {
					form[key] = mapped.form[key]
				}
			}
			if (mapped.form.tierList) {
				form.tierList = mapped.form.tierList.map(function(item) {
					return Object.assign(createTierRow(), item)
				})
			}
			this.form = form
			this.stockCategories = mapped.stockCategories
		},
		fetchConfig() {
			const configType = PUSH_CONFIG_TYPES.SAFETY_STOCK_PRICE
			if (isProductPushConfigScope(this.retailShop)) {
				const productId = getProductPushConfigId(this.retailShop)
				if (!productId) {
					return
				}
				this.loading = true
				fetchGoodsPushConfig(this.$axios, productId, configType).then(data => {
					this.applyConfig(data)
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '获取安全库存改价格配置失败')
				}).finally(() => {
					this.loading = false
				})
				return
			}
			const shopId = getRetailShopId(this.retailShop)
			if (!shopId) {
				return
			}
			this.loading = true
			fetchPushConfig(this.$axios, shopId, configType).then(data => {
				this.applyConfig(data)
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取安全库存改价格配置失败')
			}).finally(() => {
				this.loading = false
			})
		},
		onAddTier() {
			this.form.tierList.push(createTierRow())
		},
		onRemoveTier(index) {
			if (this.form.tierList.length <= 1) {
				this.$message.warning('至少保留一条阶梯配置')
				return
			}
			this.form.tierList.splice(index, 1)
		},
		onSaveAll() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				const tierCheck = validateProfitTierList(this.form.tierList)
				if (!tierCheck.valid) {
					this.$message.warning(tierCheck.message)
					return
				}
				const saveForm = this.isTaobao
					? Object.assign({}, this.form, { singleBuyMarkup: 0 })
					: this.form
				let payload
				if (isProductPushConfigScope(this.retailShop)) {
					const productId = getProductPushConfigId(this.retailShop)
					if (!productId) {
						this.$message.warning('商品信息不完整')
						return
					}
					payload = buildGoodsSafetyStockPriceSavePayload(
						productId,
						saveForm,
						this.showStockConfig ? this.stockCategories : null
					)
				} else {
					const shopId = getRetailShopId(this.retailShop)
					if (!shopId) {
						this.$message.warning('店铺信息不完整')
						return
					}
					payload = buildSafetyStockPriceSavePayload(shopId, saveForm, this.stockCategories)
				}
				this.saving = true
				const saveRequest = isProductPushConfigScope(this.retailShop)
					? saveGoodsPushConfig(this.$axios, payload)
					: savePushConfig(this.$axios, payload)
				saveRequest.then(() => {
					this.fetchConfig()
					this.$message.success('保存成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			})
		},
		applyBatch() {
			if (!this.stockCategories.length) {
				this.$message.warning('暂无安全库存配置')
				return
			}
			if (this.batchStock === undefined && this.batchDiscount === undefined) {
				this.$message.warning('请填写安全库存或安全折扣')
				return
			}
			var batchStock = this.batchStock !== undefined && this.batchStock !== null && this.batchStock !== ''
				? Math.round(Number(this.batchStock))
				: undefined
			var batchDiscount = this.batchDiscount !== undefined && this.batchDiscount !== null && this.batchDiscount !== ''
				? Math.round(Number(this.batchDiscount) * 100) / 100
				: undefined
			this.stockCategories.forEach(category => {
				category.items.forEach(item => {
					if (batchStock !== undefined) item.stock = batchStock
					if (batchDiscount !== undefined) item.discount = batchDiscount
				})
			})
			this.$message.success('已批量应用到本页全部尺码')
		},
	},
}
</script>

<style scoped lang="less">
.safety-stock-price-rule {
	padding: 24px 28px 40px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
	overflow-x: hidden;
}

.page-info {
	margin-bottom: 16px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.page-tips {
	margin-bottom: 20px;
	padding: 12px 16px;
	background: #fafbfc;
	border-radius: 6px;
	border: 1px solid #f0f2f5;

	p {
		margin: 0;
		font-size: 13px;
		line-height: 1.7;
		color: #909399;
	}

	&--warn {
		border-color: rgba(230, 162, 60, 0.25);
		background: rgba(230, 162, 60, 0.06);

		p {
			color: #b88230;
		}
	}

	&--inner {
		margin-bottom: 16px;
	}

	.tips-subtitle {
		margin: 0 0 8px;
		font-size: 13px;
		font-weight: 500;
		color: #606266;

		& + .tips-list {
			margin-bottom: 14px;
		}
	}

	.tips-list {
		margin: 0 0 14px;
		padding-left: 18px;
		font-size: 13px;
		line-height: 1.9;
		color: #909399;
	}

	.tips-example {
		margin: 0;
		padding-top: 10px;
		border-top: 1px dashed #ebeef5;
		font-size: 12px;
		color: #b0b3b8;
		line-height: 1.7;
	}

	.tips-hint {
		margin: 0 0 8px;
		font-size: 13px;
		line-height: 1.8;
		color: #f56c6c;

		&:last-of-type {
			margin-bottom: 0;
		}
	}
}

.save-bar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 24px;
	padding-bottom: 20px;
	border-bottom: 1px solid #f2f3f5;

	.el-button {
		min-width: 96px;
		height: 36px;
	}

	.save-note {
		font-size: 12px;
		color: #b0b3b8;
		line-height: 1.5;
	}
}

.config-form {
	max-width: 100%;
}

.rule-collapse {
	border: none;

	/deep/ .collapse-narrow .el-collapse-item__content {
		max-width: none;
	}

	/deep/ .collapse-narrow .page-tips--inner {
		width: 100%;
		box-sizing: border-box;
	}

	/deep/ .stock-panel-item .el-collapse-item__content {
		padding-left: 0;
		padding-right: 0;
		overflow: visible;
	}

	/deep/ .el-collapse-item__header {
		height: 48px;
		padding: 0 4px 0 16px;
		font-size: 14px;
		font-weight: 500;
		color: #303133;
		background: #f7f9fc;
		border: 1px solid #eef0f3;
		border-radius: 6px;
		margin-bottom: 12px;
	}

	/deep/ .el-collapse-item__wrap {
		border: none;
	}

	/deep/ .el-collapse-item__content {
		padding: 8px 4px 20px;
	}

	/deep/ .el-collapse-item {
		margin-bottom: 8px;
	}
}

.stock-panel {
	margin-left: calc(-28px - 10px);
	margin-right: calc(-28px - 10px);
	padding-left: calc(28px + 10px);
	padding-right: calc(28px + 10px);
	width: calc(100% + 76px);
	max-width: calc(100% + 76px);
	box-sizing: border-box;
}

.field-wrap {
	max-width: 360px;

	.el-select,
	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fafbfc;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}
}

.field-tip {
	margin: 6px 0 0;
	font-size: 11px;
	color: #b0b3b8;
	line-height: 1.5;
}

.price-section-note {
	margin: 0 0 4px;
	padding-left: 240px;
	font-size: 12px;
	line-height: 1.5;
	color: #b0b3b8;
}

.radio-group {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-top: 10px;

	/deep/ .el-radio {
		margin-right: 0;
		line-height: 1.6;
		white-space: normal;
	}
}

.section-note {
	margin: 0;
	font-size: 12px;
	color: #b0b3b8;
}

.tier-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 14px;
}

.tier-add-btn {
	padding: 0;
	font-size: 13px;
	color: #ff4714;

	&:hover {
		color: #ff4714;
		opacity: 0.75;
	}
}

.action-link {
	font-size: 13px;
	color: #ff4714;
	cursor: pointer;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.7;
	}
}

.tier-table {
	border: 1px solid #f0f2f5;
	border-radius: 6px;
	overflow: hidden;
}

.tier-row {
	display: flex;
	align-items: center;
	padding: 12px 16px;
	border-bottom: 1px solid #f5f6f8;

	&:last-child {
		border-bottom: none;
	}

	&--head {
		background: #fafbfc;
		font-size: 13px;
		color: #909399;
		font-weight: 500;
		padding: 10px 16px;
	}
}

.col-range {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;

	.el-input-number {
		width: 120px;
		flex-shrink: 0;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
}

.range-sep {
	font-size: 13px;
	color: #909399;
	white-space: nowrap;
	flex-shrink: 0;
}

.col-profit {
	width: 160px;
	flex-shrink: 0;

	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
}

.col-action {
	width: 72px;
	flex-shrink: 0;
	text-align: center;
}

.stock-tip {
	margin-bottom: 16px;
	padding: 10px 14px;
	font-size: 13px;
	color: #909399;
	background: #f7f9fc;
	border-radius: 4px;
}

.stock-empty {
	padding: 24px 16px;
	font-size: 13px;
	color: #909399;
	text-align: center;
	background: #fafbfc;
	border: 1px dashed #e8eaed;
	border-radius: 6px;
}

.batch-bar {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 16px;
	margin-bottom: 20px;
	padding: 14px 16px;
	background: #fafbfc;
	border-radius: 6px;
	border: 1px solid #f0f2f5;
}

.batch-label {
	font-size: 14px;
	font-weight: 500;
	color: #303133;
}

.batch-field {
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
	color: #606266;

	.el-input-number {
		width: 88px;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
}

.stock-category {
	display: flex;
	align-items: stretch;
	margin-bottom: 12px;
	border: 1px solid #f0f2f5;
	border-radius: 6px;
	overflow: hidden;
	width: 100%;
	box-sizing: border-box;
	background: #fafbfc;
}

.cat-label {
	flex-shrink: 0;
	width: 64px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 6px;
	font-size: 13px;
	font-weight: 500;
	color: #606266;
	background: #fafbfc;
	border-right: 1px solid #f0f2f5;
	text-align: center;
	line-height: 1.4;
	word-break: break-all;
}

.size-scroll {
	flex: 1;
	min-width: 0;
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(72px, 1fr));
	overflow: hidden;
	padding: 10px 8px;
	gap: 8px;
	box-sizing: border-box;
	background: #fafbfc;
	align-content: start;
}

.size-cell {
	width: 100%;
	min-width: 0;
	padding: 8px 4px;
	background: #fff;
	border-radius: 4px;
	border: 1px solid #eef0f3;
	box-sizing: border-box;
}

.size-name {
	display: block;
	margin-bottom: 6px;
	font-size: 12px;
	font-weight: 500;
	color: #303133;
	text-align: center;
	line-height: 1.3;
}

.size-field {
	& + .size-field {
		margin-top: 6px;
	}

	.field-label {
		display: block;
		margin-bottom: 4px;
		font-size: 11px;
		color: #909399;
		text-align: center;
		line-height: 1.2;
	}

	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: center;
		padding: 0 4px;
		height: 28px;
		line-height: 28px;
		font-size: 12px;
		color: #303133;
		background: #fafbfc;
		border-color: #e8eaed;
		border-radius: 4px;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/safetyStockPriceRule.vue